import React from "react";
import { css, select } from "glamor";
import Link from "./Link";
import { colors, spacing, typographyColors } from "./theme";

const iconClass = css({
  marginLeft: spacing.s,
  marginRight: spacing.s,
  opacity: 0.3,
});
const activeClass = css(
  {
    cursor: "pointer",
    color: `#009EDE !important`,
    "@media(max-width: 768px)": {
      borderBottom: "none",
      background: colors.greyClear,
      width: "100%",
    },
  },
  select(`& .${iconClass}`, {
    transition: ".3s opacity",
    opacity: 1,
  })
);
const item = css({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  color: `${typographyColors.defaultBody} !important`,
  fontWeight: "bold !important",
  padding: spacing.xs,
  borderRadius: 8,
  "&:hover": {
    ...activeClass,
  },
  "&:visited": {
    color: "inherit",
  },
});
const subItemClass = css({
  fontSize: 14,
  paddingLeft: 24,
  lineHeight: 1.5,
});
const disabledClass = css({
  color: colors.greyLight,
  pointerEvents: "none",
  userSelect: "none",
  "&:hover": {
    borderBottom: "none",
  },
  "&:visited": {
    borderBottom: "none",
    color: colors.greyLight,
  },
});

export default function MenuItem(props) {
  const {
    name,
    label,
    icon,
    active,
    children,
    subItem,
    className,
    disabled,
    onClick,
    ...rest
  } = props;
  const baseClass = css(
    item,
    subItem && subItemClass,
    className && className,
    active && activeClass,
    disabled && disabledClass
  );
  const Icon = icon;

  const handleClick = () => {
    onClick({ name });
  };

  return (
    <Link className={baseClass} onClick={handleClick} {...rest}>
      {icon && <Icon size={subItem ? 16 : 22} className={iconClass} />}
      {label || children}
    </Link>
  );
}
